module.exports = __webpack_public_path__ + "media/tts_g1_b.cafd84c4.mp3";